import React from 'react'

const Banner = () => {

    const words = [
        "Reply"," Student Tech Clash", "AI on Campus", "Education", "Training", "Learning"
    ]

  return (
    <section className='w-screen py-4 border-y border-brand-white/50 bg-brand-black'>
        <article className='flex w-max slider-left gap-6 md:gap-10'>
            <div className='flex w-max gap-6 md:gap-10'>
                {
                    [...words, ...words].map((item, i)=>{
                        return i%2 == 0 
                        ? <h3 key={i} className='text-sm md:text-md shrink-0 text-brand-white uppercase font-mono text-nowrap'>{item}</h3> 
                        : <h3 key={i} className='text-sm md:text-md shrink-0 text-brand-blue uppercase font-mono text-wrap'>{item}</h3>
                    })
                }
            </div>
            <div className='flex w-max gap-6 md:gap-10'>
                {
                    [...words, ...words].map((item, i)=>{
                        return i%2 == 0 
                        ? <h3 key={i} className='text-sm md:text-md shrink-0 text-brand-white uppercase font-mono text-nowrap'>{item}</h3> 
                        : <h3 key={i} className='text-sm md:text-md shrink-0 text-brand-blue uppercase font-mono text-wrap'>{item}</h3>
                    })
                }
            </div>
        </article>
    </section>
  )
}

export default Banner